<div>
    <div class="flex items-center mb-1">
        <!-- <h2 mat-dialog-title class="text-lg font-bold mb-1"></h2> -->
        <mat-icon svgIcon="heroicons_outline:x-circle" matTooltip="Cerrar" class="close-button" mat-dialog-close style="cursor: pointer;"></mat-icon>
    </div>

    <mat-dialog-content class="modal-content">
        <div class="top-0">
            <table class="min-w-500 overflow-y-visible mat-elevation-z" mat-table [dataSource]="dataSourceHistoric" 
                matSort multiTemplateDataRows>
                <ng-container matColumnDef="expand">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let historic">
                        <ng-container *ngIf="historic?.hasScalePrices && historic?.scalePrices?.length > 0">
                            <button mat-icon-button (click)="historic.expanded = !historic.expanded">
                                <mat-icon>{{historic.expanded ? 'expand_less' : 'expand_more'}}</mat-icon>
                            </button>
                        </ng-container>
                    </td>
                </ng-container>

                <ng-container matColumnDef="codePriceList">
                    <th mat-header-cell *matHeaderCellDef class="px-6 text-center">Código</th>
                    <td mat-cell *matCellDef="let historic" class="px-6 text-center">
                    </td>
                </ng-container>
      
                <ng-container matColumnDef="namePriceList">
                    <th mat-header-cell *matHeaderCellDef class="px-6 text-left">Lista Precio</th>
                    <td mat-cell *matCellDef="let historic" class="px-6 text-left">
                        <b>{{historic?.codePriceList}}</b><br>
                        <span class="block mt-1 text-sm break-words max-w-[200px] text-left sm:max-w-none">{{historic?.namePriceList}}</span>
                    </td>
                </ng-container>
        
                <ng-container matColumnDef="price">
                    <th mat-header-cell *matHeaderCellDef class="px-6 text-right">Precio {{ 'code' | companyCurrency: true }}</th>
                    <td mat-cell *matCellDef="let historic" class="px-6 text-right">
                        {{historic?.price | number: '1.2-2'}} {{historic.codeCurrency}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="igv">
                    <th mat-header-cell *matHeaderCellDef class="px-6 text-right">Precio + Impuesto {{ 'code' | companyCurrency: true }}</th>
                    <td mat-cell *matCellDef="let historic" class="px-6 text-right">
                        {{(historic?.price + (historic?.price * 1.18)) | number: '1.2-2'}} {{historic.codeCurrency}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="nestedTable">
                    <td mat-cell *matCellDef="let historic" [attr.colspan]="displayedColumnsHistoric.length">
                        <div *ngIf="historic?.hasScalePrices && historic?.scalePrices?.length > 0" class="tablein overflow-hidden"
                            [@detailExpand]="historic.expanded ? 'expanded' : 'collapsed'">

                            <table class="min-w-500 overflow-y-visible mat-elevation-z" mat-table
                                [dataSource]="historic.scalePrices" class="w-full nested-table">


                                <tr mat-header-row *matHeaderRowDef="displayedColumnsDetail" class="bg-gray-100"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumnsDetail; let i = index"
                                [trackBy]="trackByLabelFn" ></tr>
                            </table>
                        </div>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnsHistoric" class="bg-gray-100"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsHistoric; let i = index"
                 [trackBy]="trackBy" class="border-b"></tr>

               <tr mat-row *matRowDef="let row; columns: ['nestedTable']; when: isExpansionDetailRow" class="table-detail-row"></tr>

            </table>
        </div>
        <div *ngIf="this.dataSourceHistoric.data.length === 0" class="border-t p-8 text-center text-1xl sm:p-10">Lo sentimos, no hay registros para mostrar.
        </div>
    </mat-dialog-content>
</div>